export default {
  name: 'page3'
};